import React, { useState, useRef, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import DialogContentText from "@mui/material/DialogContentText";
import { ListBoxComponent } from "@syncfusion/ej2-react-dropdowns";
import Box from "@mui/material/Box";

import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";
import "./styles/Settings.css";

function SettingsFavoriteProjects(props) {
  const creds = useContext(CredsContext).creds;

  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);
  let leftList;
  let rightList;
  let clientProjectList = [];
  let favoritesList = [];
  const [dirty, isDirty] = useState(false);

  const rawFavoritesList = localStorage.getItem(
    creds.company + "|FavoriteProjects",
  );

  if (rawFavoritesList) {
    favoritesList = JSON.parse(rawFavoritesList);
  }

  const rawClientProjectList = localStorage.getItem(
    creds.company + "|ClientsProjects",
  );

  if (rawClientProjectList) {
    clientProjectList = JSON.parse(rawClientProjectList);
  } else {
    props.waitHandler(
      true,
      "Loading full client list, this may take 30-60 seconds",
    );
    const requestString =
      authString +
      '<Read type="Project" method="equal to"><Project><active>1</active></Project></Read></request>';
    Tools.fetchPost(requestString, urlString, "Project").then(
      (rawProjResult) => {
        const projectArray = Tools.xmlToArray(rawProjResult.xml);
        projectArray.forEach((projRec) =>
          clientProjectList.push({
            clientproject: projRec.customer_name + ":" + projRec.name,
            client: projRec.customer_name,
            project: projRec.name,
            projectId: projRec.id,
          }),
        );
        clientProjectList.sort((a, b) => {
          if (a.clientproject < b.clientproject) {
            return -1;
          }
          if (a.clientproject > b.clientproject) {
            return 1;
          }
          // names must be equal
          return 0;
        });
        console.log(JSON.stringify(clientProjectList));
        localStorage.setItem(
          creds.company + "|ClientsProjects",
          JSON.stringify(clientProjectList),
        );

        const today = new Date();

        let prefUpdateString =
          authString +
          '<Add type="Preference"><Preference><group_name>oadaSettings</group_name><name>lastProjectRefresh</name><setting>' +
          today.getTime() +
          "</setting></Preference></Add></request>";

        const lastProjectRefreshString =
          authString +
          '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>oadaSettings</group_name><name>lastProjectRefresh</name></Preference></Read></request>';
        Tools.fetchPost(lastProjectRefreshString, urlString, "Preference").then(
          (rawPrefResult) => {
            const prefArray = Tools.xmlToArray(rawPrefResult.xml);
            if (prefArray && prefArray[0] && prefArray[0].id) {
              prefUpdateString = prefUpdateString =
                authString +
                '<Modify type="Preference"><Preference><id>' +
                prefArray[0].id +
                "</id><setting>" +
                today.getTime() +
                "</setting></Preference></Modify></request>";

              Tools.fetchPost(prefUpdateString, urlString);
              props.waitHandler(false);
              isDirty(!dirty);
            } else {
              Tools.fetchPost(prefUpdateString, urlString);
              props.waitHandler(false);
              isDirty(!dirty);
            }
          },
        );
      },
    );
  }

  let transferListFields = {
    text: "clientproject",
    value: "clientproject",
    id: "projectId",
  };
  let transferListToolbar = {
    items: ["moveTo", "moveFrom", "moveAllTo", "moveAllFrom"],
  };

  const handleListBoxChange = (event) => {
    let listId;
    if (event.elements.length > 0) {
      listId = event.elements[0].parentElement.id;
      if (listId == "leftlistbox_parent") {
        rightList.selectAll(false);
      }
      if (listId == "rightlistbox_parent") {
        leftList.selectAll(false);
      }
    }
    /*
    attempted to add doubleclick functionality, aborted

    if (event.event && event.event.type == "click") {
      if (event.items[0].projectId == previousSelection.current) {
        previousSelection.current = null;
        if (listId == "leftlistbox_parent") {
          event.eventName = "moveTo";
          rightList.addItems(event.items[0]);
          const removeIndex = leftList.listData.findIndex(
            (elem) => elem.projectId == event.items[0].projectId,
          );
          if (removeIndex) {
            leftList.removeItem(null, removeIndex);
          }
        } else if (listId == "rightlistbox_parent") {
          event.eventName = "moveFrom";
          leftList.addItems(event.items[0]);
          const removeIndex = rightList.dataSource.findIndex(
            (elem) => elem.projectId == event.items[0].projectId,
          );
          if (removeIndex >= 0) {
            rightList.removeItem(null, removeIndex);
          }
        }
        listBoxActionComplete(event);
        isDirty(!dirty);
      } else {
        previousSelection.current = event.items[0].projectId;
      }
    }*/
  };

  const listBoxActionComplete = (event) => {
    //if (event.eventName == "moveTo" || event.eventName == "moveFrom") {
    if (event.eventName == "moveTo") {
      event.items.forEach((elem) => favoritesList.push(elem));

      event.items.forEach((itemsElem) => {
        const indexToRemove = clientProjectList.findIndex(
          (elem) => elem.projectId == itemsElem.projectId,
        );
        clientProjectList.splice(indexToRemove, 1);
      });
    } else if (event.eventName == "moveFrom") {
      event.items.forEach((elem) => clientProjectList.push(elem));
      event.items.forEach((itemsElem) => {
        const indexToRemove = favoritesList.findIndex(
          (elem) => elem.projectId == itemsElem.projectId,
        );
        favoritesList.splice(indexToRemove, 1);
      });
    }

    localStorage.setItem(
      creds.company + "|FavoriteProjects",
      JSON.stringify(favoritesList),
    );

    localStorage.setItem(
      creds.company + "|ClientsProjects",
      JSON.stringify(clientProjectList),
    );

    const favoritesListString = JSON.stringify(favoritesList)
      .replace(/&/gm, "&amp;")
      .replace(/</gm, "&lt;")
      .replace(/>/gm, "&gt;");

    const requestPrefString =
      authString +
      '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>oadaSettings</group_name><name>' +
      creds.company +
      "|FavoriteProjects</name><userid>" +
      creds.id +
      "</userid></Preference></Read></request>";
    Tools.fetchPost(requestPrefString, urlString, "Preference").then(
      (rawPrefXml) => {
        if (rawPrefXml.xml && rawPrefXml.xml.length > 0) {
          const prefRec = Tools.xmlToArray(rawPrefXml.xml);
          const updateId = prefRec[0].id;
          const modString =
            authString +
            '<Modify type="Preference"><Preference><id>' +
            updateId +
            "</id><setting>" +
            favoritesListString +
            "</setting></Preference></Modify></request>";
          Tools.fetchPost(modString, urlString);
        } else {
          const addString =
            authString +
            '<Add type="Preference"><Preference><group_name>oadaSettings</group_name><name>' +
            creds.company +
            "|FavoriteProjects</name><userid>" +
            creds.id +
            "</userid><setting>" +
            favoritesListString +
            "</setting></Preference></Add></request>";
          Tools.fetchPost(addString, urlString);
        }
      },
    );
    //}
  };

  if (
    clientProjectList &&
    clientProjectList.length > 0 &&
    favoritesList &&
    favoritesList.length > 0
  ) {
    for (let x = 0; x < favoritesList.length; x++) {
      const index = clientProjectList.findIndex(
        (elem) => elem.projectId == favoritesList[x].projectId,
      );
      if (index !== undefined && index >= 0) {
        clientProjectList.splice(index, 1);
      }
    }
  }

  useEffect(() => {
    const buttons = document.getElementsByClassName("e-btn");
    if (buttons && buttons.length > 0) {
      for (let z = 0; z < buttons.length; z++) {
        console.log(buttons[z].dataset.value);
        if (
          buttons[z].dataset.value == "moveAllTo" ||
          buttons[z].dataset.value == "moveAllFrom"
        ) {
          buttons[z].style.display = "none";
        }
      }
    }
  });

  return (
    <Box>
      <DialogContentText
        id="alert-dialog-description"
        sx={{ color: "white", marginTop: "10px" }}
      >
        Select clients/projects for Favorites list:
      </DialogContentText>
      <Box
        display="flex"
        sx={{
          width: "850px",
          height: "30px",
          backgroundColor: "#454545",
          borderRadius: "15px 15px 0px 0px",
          justifyContent: "space-between",
          color: "white",
          marginTop: "10px",
          paddingTop: "5px",
        }}
      >
        <span></span>
        <span style={{ fontSize: "18px" }}>Clients : Projects</span>
        <span></span>
        <span style={{ fontSize: "18px" }}>Favorites</span>
        <span></span>
      </Box>
      <ListBoxComponent
        ref={(leftRef) => (leftList = leftRef)}
        id="leftlistbox"
        dataSource={clientProjectList}
        fields={transferListFields}
        scope="#rightlistbox"
        sortOrder="Ascending"
        toolbarSettings={transferListToolbar}
        change={handleListBoxChange}
        cssClass="settingsClientProjectDualListLeft"
        actionComplete={listBoxActionComplete}
        allowFiltering={true}
        filterBarPlaceholder="Search (contains)...."
        filterType="Contains"
      />
      <ListBoxComponent
        ref={(rightRef) => (rightList = rightRef)}
        id="rightlistbox"
        dataSource={favoritesList}
        fields={transferListFields}
        scope="#leftlistbox"
        sortOrder="Ascending"
        change={handleListBoxChange}
        cssClass="settingsClientProjectDualListRight"
        actionComplete={listBoxActionComplete}
        noRecordsTemplate='<div style="padding-top:10px; padding-left:10px">No projects selected</div>'
      />
    </Box>
  );
}

export default SettingsFavoriteProjects;

SettingsFavoriteProjects.propTypes = {
  waitHandler: PropTypes.func,
};

/*
  <ListBoxComponent
        ref={(leftRef) => (lists.current.left = leftRef)}
        id="leftlistbox"
        dataSource={approvalMembers.current}
        fields={transferListFields}
        scope="#rightlistbox"
        toolbarSettings={transferListToolbar}
        cssClass="reqDualListLeft"
        change={handleListBoxChange}
        actionComplete={actionCompleteLeft}
      />
      <ListBoxComponent
        ref={(rightRef) => (lists.current.center = centerRef)}
        id="rightlistbox"
        dataSource={projectTeam.current}
        fields={transferListFields}
        scope="#rightlistbox"
        toolbarSettings={transferListToolbar}
        cssClass="reqDualListCenter"
        change={handleListBoxChange}
        actionComplete={actionCompleteCenter}
      />
      */
